import { useCallback, useRef, useEffect } from 'react';
import throttleWithTrailing from '../utils/throttleWithTrailing';
import { captureException } from '../utils/sentryAPI';
const useUpdateSidebarWidth = (isNotificationsOpen, invokeSidebar) => {
  const latestInvokeSidebarRef = useRef(invokeSidebar);
  useEffect(() => {
    latestInvokeSidebarRef.current = invokeSidebar;
  }, [invokeSidebar]);
  const handleResize = useCallback(() => {
    latestInvokeSidebarRef.current('onScreenSizeChange', {
      width: window.innerWidth
    }).catch(e => {
      captureException(e);
    });
  }, []);
  const throttledHandleResize = useRef(throttleWithTrailing(handleResize, 100)).current;
  useEffect(() => {
    if (isNotificationsOpen) {
      window.addEventListener('resize', throttledHandleResize);
      throttledHandleResize();
      return () => {
        window.removeEventListener('resize', throttledHandleResize);
      };
    }
  }, [isNotificationsOpen, throttledHandleResize]);
};
export default useUpdateSidebarWidth;